import React, { useEffect, useState } from "react";
import { FileText, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useNavigate } from "react-router-dom";
import { api, openPdf, errMsg } from "@/lib/api";import { useApp } from "@/context/AppContext";

export default function Prescriptions() {
  const { fq } = useApp();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
 const load = () => {
  api.get(`/prescriptions${fq ? `?${fq}` : ""}`)
    .then(({ data }) => setRows(data))
    .catch(() => {});
};

useEffect(() => {
  load();
}, [fq]);

  const deletePrescription = async (id) => {
  if (!window.confirm("Move this prescription to Recycle Bin?")) return;

  try {
    await api.delete(`/prescriptions/${id}`);
    toast.success("Prescription moved to Recycle Bin");
    load();
  } catch (e) {
    toast.error(errMsg(e));
  }
};
  return (
    <div className="space-y-5" data-testid="prescriptions-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-primary">Documents</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Prescriptions</h1>
      </div>
      <Card className="shadow-sm">
        <CardContent className="p-0">
          <Table data-testid="prescriptions-table">
            <TableHeader>
              <TableRow>
                <TableHead>Rx number</TableHead><TableHead>Patient</TableHead><TableHead>Doctor</TableHead>
                <TableHead>Medicines</TableHead><TableHead>Date</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={6} className="text-center py-10 text-sm text-muted-foreground">
                  No prescriptions yet.
                </TableCell></TableRow>
              )}
              {rows.map((r) => (
                <TableRow key={r.id} data-testid={`prescription-row-${r.id}`} className="hover:bg-muted/50">
                  <TableCell className="font-mono text-xs">{r.number}</TableCell>
                  <TableCell className="font-medium">{r.patient_name}</TableCell>
                  <TableCell>{r.doctor_name}</TableCell>
                  <TableCell>{(r.medicines || []).length}</TableCell>
                  <TableCell className="text-xs">{new Date(r.created_at).toLocaleDateString()}</TableCell>
                  <TableCell className="text-right space-x-2">
                    <Button size="sm" variant="outline" className="gap-1.5" data-testid={`rx-pdf-${r.id}`}
                      onClick={() => openPdf(`/prescriptions/${r.id}/pdf`)}>
                      <FileText className="h-3.5 w-3.5" /> PDF
                    </Button>
                    <Button size="sm" variant="ghost" onClick={() => nav(`/consultation/${r.consultation_id}`)}>
                      Open
                    </Button>
                    <Button
  size="sm"
  variant="destructive"
  onClick={() => deletePrescription(r.id)}
>
  <Trash2 className="h-3.5 w-3.5 mr-1" />
  Delete
</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
